<!-- 课程列表 -->
<template>
    <div class="courseList">
        <div class="conditionSearchBox">
            <!-- <div class="conditionSearchItem">
                <el-select v-model="params.condition.catecode" placeholder="请选择类型">
                    <el-option v-for="item in cate" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div> -->
            <div class="conditionSearchItem">
                <el-input placeholder="课程名称" prefix-icon="el-icon-search" v-model="params.condition.name"></el-input>
            </div>
            <div class="btnBox">
                <el-button type="hollowOut" icon="el-icon-search" @click="triggerSearch">搜索</el-button>
                <el-button icon="el-icon-refresh"  @click="triggerReset">重置</el-button>
            </div>
        </div>
        <div class="handleBox">
            <el-button icon="el-icon-plus" type="primary" @click="handleAddCourse">新增课程</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" border v-loading="contentLoading" class="table-fixed-col">
            <el-table-column label="序号" align="center" width="70px" fixed="left" key="sort">
                <template slot-scope="scope">
                    {{scope.$index + 1 + (params.page - 1) * 20}}
                </template>
            </el-table-column>
            <el-table-column label="课程名称" align="center" min-width="200px" show-overflow-tooltip  fixed="left" key="name">
                <template slot-scope="scope">
                    <div class="text-ellipse">{{scope.row.name}}</div>
                </template>
            </el-table-column>
            <el-table-column label="所属类目" align="center" width="200px" show-overflow-tooltip key="catename">
                <template slot-scope="scope">
                    <div class="text-ellipse">{{scope.row.catename ? scope.row.catename : '--'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="课时数" align="center" width="150px" key="periodcount">
                <template slot-scope="scope">
                    <div class="text-ellipse">{{scope.row.periodcount ? scope.row.periodcount : '--'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="授课老师" align="center" min-width="200px" show-overflow-tooltip key="teachername">
                <template slot-scope="scope">
                    <div class="text-ellipse">{{scope.row.teachername ? scope.row.teachername : '--'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center" width="200px" show-overflow-tooltip key="datetime">
                <template slot-scope="scope">
                    <div class="text-ellipse">{{scope.row.datetime ? scope.row.datetime : '--'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="100px" key="statusname">
                <template slot-scope="scope">
                    <div class="text-ellipse" :class="['status' + scope.row.status]">{{scope.row.statusname}}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="right" :width="getTableHeaderWidthByOpButton5()" fixed="right" key="handle">
                <template slot-scope="scope">
                    <div class="handleItemBox flex jc-sb ai-c">
                        <div class="handleItem color-brand pointer" @click="handleEdit(scope.row)">编辑</div>
                        <div class="handleItem color-brand pointer" @click="handleSection(scope.row)">章节</div>
                        <div class="handleItem" :class="[scope.row.status === 0 || scope.row.status === 11 ? 'color-brand pointer' : 'disabled']" @click="handleIssue(scope.row)">发布</div>
                        <div class="handleItem" :class="[scope.row.status === 10 ? 'color-brand pointer' : 'disabled']" @click="handlePause(scope.row)">暂停</div>
                        <div class="handleItem" :class="[scope.row.status === 0 || scope.row.status === 10 || scope.row.status === 11 ? 'color-brand pointer' : 'disabled']" @click="handleDelete(scope.row, scope.$index)">删除</div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Page @pageChange="pageChange" @pagesizeChange="pagesizeChange" :page="params.page" :pagesize="params.pagesize" :total="total" />
        <MaintainCourse @maintainCourseSuccess="maintainCourseSuccess" ref="maintainCourse" />
    </div>
</template>

<script>
import {getCourseList, updateCourseStatus} from '@/api/measApi/courseManage.js'
import Page from '@/components/measComponents/page/page.vue'
import MaintainCourse from './components/maintainCourse.vue'
export default {
    data() {
        return {
            params: {
                condition: {
                    catecode: '', // 类型code
                    catename: '', // 类型名称
                    classcode: '', // 班级code
                    classname: '', // 班级名
                    name: '', // 课程名称
                    status: '' // 状态：0草稿 10正常 11暂停 30已结业 100已删除'
                },
                orderbyname: '', // 排序字段code
                orderbyorder: '', // 排序 asc-升序 desc-降序
                page: 1, // 页码
                pagesize: this.getTableDefaultPageSize() // 每页大小
                // pagesize: 2 // 每页大小
            },
            cate: [
                {label: '创投微课程', value: ''}
            ],
            contentLoading: false,
            tableData: [],
            total: 0
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getCourseList()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        // 新增课程
        handleAddCourse() {
            this.$refs.maintainCourse.handleOpen()
        },
        pageChange(page) {
            this.params.page = page
            this.getCourseList()
        },
        pagesizeChange(pagesize) {
            this.params.pagesize = pagesize
            this.getCourseList()
        },
        triggerSearch() {
            this.params.page = 1
            this.params.pagesize = this.getTableDefaultPageSize()
            this.getCourseList()
        },
        triggerReset() {
            this.params.condition.catecode = ''
            this.params.condition.catename = ''
            this.params.condition.classcode = ''
            this.params.condition.classname = ''
            this.params.condition.name = ''
            this.params.condition.status = ''
            this.triggerSearch()
        },
        getCourseList() {
            this.contentLoading = true
            getCourseList(this.params).then(res => {
                this.contentLoading = false
                if (res.code === '000') {
                    this.tableData = res.data
                    this.total = res.pageinfo.rowcount
                }
            })
        },
        // 维护课程成功
        maintainCourseSuccess(code) {
            if (code) { // 编辑成功
                this.getCourseList()
            } else {
                this.params.page = 1
                this.getCourseList()
            }
        },
        // 编辑
        handleEdit(row) {
            this.$refs.maintainCourse.handleOpen(row.code)
        },
        // 章节
        handleSection(row) {
            this.$router.push({name: 'CourseMsg', query: {courseCode: row.resourcecode}})
        },
        // 发布
        handleIssue(row) {
            if(row.status === 0 || row.status === 11) {
                updateCourseStatus({code: row.code, status: 10}).then(res => {
                    if (res.code === '000') {
                        this.$message.success(res.msg)
                        row.status = 10
                        row.statusname = '正常'
                    }
                })
            }
        },
        // 暂停
        handlePause(row) {
            if (row.status === 10) {
                updateCourseStatus({code: row.code, status: 11}).then(res => {
                    if (res.code === '000') {
                        this.$message.success(res.msg)
                        row.status = 11
                        row.statusname = '暂停'
                    }
                })
            }
        },
        // 删除
        handleDelete(row, index) {
            if (row.status === 0 || row.status === 10 || row.status === 11) {
                this.$confirm('课程删除后将不在前台展示，但不影响现有的排课信息，继续吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'measElMessage'
                }).then(() => {
                    updateCourseStatus({code: row.code, status: 100}).then(res => {
                        if (res.code === '000') {
                            this.$message.success(res.msg)
                            if (this.total <= this.params.pagesize) {
                                this.tableData.splice(index, 1)
                                this.total--
                            } else if (this.tableData.length === 1 && this.params.page > 1) {
                                this.params.page--
                                this.getCourseList()
                            } else {
                                this.getCourseList()
                            }
                        }
                    })
                })
            }
        }
    },
    components: {
        Page,
        MaintainCourse
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .courseList {
        // background: #fff;
        // height: 100%;
        .el-table {
            .status10, .status30 {
                color: #67C23A;
            }
            .status0 {
                color: #E6A23C;
            }
            .status11 {
                color: #F56C6C;
            }
            .status100 {
                color: #7D8C9E;
            }
        }
    }
</style>